var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.065,
    height: 53.378,
    viewBox: "0 0 49.065 53.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.46 1.091a7.614 7.614 0 0 0-7.855 0l-1.747 1.052A32.991 32.991 0 0 1 4.934 6.726l-1.1.1A4.23 4.23 0 0 0 0 11.041V16.6a34.684 34.684 0 0 0 10.577 24.94l11.016 10.649a4.23 4.23 0 0 0 5.88 0L38.488 41.54A34.684 34.684 0 0 0 49.065 16.6v-5.559a4.23 4.23 0 0 0-3.833-4.211l-1.1-.1a32.991 32.991 0 0 1-13.925-4.587z",
    style: {
      fill: "#1bc47d"
    },
    "data-name": "Solid / Status /Shield"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Check"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M22.513.391a1.31 1.31 0 0 1 0 1.89L9.68 14.756a1.4 1.4 0 0 1-1.944 0L.4 7.628a1.31 1.31 0 0 1 0-1.89 1.4 1.4 0 0 1 1.944 0l6.361 6.183L20.568.391a1.4 1.4 0 0 1 1.945 0z",
    style: {
      fill: "#fff"
    },
    transform: "translate(14.927 18.292)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBadge);
export default __webpack_public_path__ + "static/media/success-badge.c451330e612bc6db0161e3f1e8b762d9.svg";
export { ForwardRef as ReactComponent };